import * as React from 'react';
import {styled, TextField} from "@mui/material";

export const BlackDisabledTextField = styled(TextField)({
    "& .MuiInputBase-input.Mui-disabled": { WebkitTextFillColor: "#656565",color: "#656565" },
});
